import { ColDef, ValueGetterParams } from 'ag-grid-community';
import {
  ColSize,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createPhoneCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import TableRowStatusBadge from '@/components/molecule/TableRowStatusBadge';
import Badge from '@/components/atom/Badge';
import { getStatusBadgeProps } from '@/src/pages/Customer/badge';
import { UNIT_STRINGS } from '@/src/constants/unit';

export const normalCustomerListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '가입 일시',
  }),
  createTypoCol({
    field: 'signupSourceName',
    size: 'sm',
    cellRenderer: ({ data }: ValueGetterParams) => {
      return data?.signupSource === null
        ? '에코야얼스'
        : data?.signupSource?.partnershipCompany?.name;
    },
    headerName: '가입 경로',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'status',
    ...ColSize.sm,
    cellRenderer: (params: ValueGetterParams) => {
      return <Badge {...getStatusBadgeProps(params?.data?.status)} />;
    },
    headerName: '회원 상태',
  },
  createTypoCol({
    field: 'nick',
    size: 'lg',
    headerName: '닉네임',
  }),
  createTypoCol({
    field: 'name',
    size: 'md',
    headerName: '회원 이름',
  }),
  createPhoneCol({
    field: 'phone',
    size: 'md',
    headerName: '핸드폰 번호',
  }),
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'credit',
    ...ColSize.sm,
    cellRenderer: (params: ValueGetterParams) => {
      const credit = params?.data?.credit?.currentCredit || '0';
      return `${credit.toLocaleString()}`;
    },
    headerName: `보유 크레딧(${UNIT_STRINGS.CREDIT})`,
  },
  {
    headerClass: 'ag-right-aligned-cell',
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    field: 'accountOptionalTerms',
    ...ColSize.md,
    cellRenderer: (params: ValueGetterParams) => {
      return (
        <TableRowStatusBadge
          type="isAgreed"
          value={!!params?.data?.account?.accountOptionalTerms}
        />
      );
    },
    headerName: '마케팅 활용 동의 여부',
  },
  createDetailButtonColV2(onDetailClick),
];
